import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getFatigueAssessment } from 'shared/services/fatigueAssessmentApi';
import { FatigueAssessmentForm } from 'shared/models/api/models';
import FatigueAssessmentPage from "./FatigueAssessmentPage";
import { fatigueAssessmentForm } from "./FatigueAssessmentPageSelector";
import FormContents from "./FormContents";
import { toLocalDateTimeFields } from 'shared/models/mapping/mapping';

const FatigueAssessmentBaseForm = () => {
    const [assessment, setAssessment] = useState({} as FatigueAssessmentForm);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        async function getData() {
            const idString = location.pathname.split('/')[3];
            if (idString !== undefined) {
                setLoading(true);
                const id = Number.parseInt(idString)
                let form = await getFatigueAssessment(id);
                // Converting the date strings from the api is problematic on safari
                form = toLocalDateTimeFields(form, ['assessmentDate', 'shiftStartTime', 'dateOfIssue']);
                setAssessment(form);
            }
            setLoading(false);
        }
        getData();
    }, [location]);

    return (
        <FatigueAssessmentPage selectedPage={fatigueAssessmentForm}>
            <FormContents loading={loading} assessment={assessment}></FormContents>
        </FatigueAssessmentPage>
    );
}

export default FatigueAssessmentBaseForm;
